/**
 * Preference entity descriptors (platform `@rammetec/data-access/preferences`).
 *
 * Registered under {@link PREFERENCE_ENTITY} names so `PreferencesService.hydrate`
 * can resolve repositories via the entity registry.
 */
import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { createPreferenceDescriptors, PREFERENCE_ENTITY, } from '@rammetec/data-access/preferences';
export const preferenceDescriptors = createPreferenceDescriptors({
    dataSource: DataSourceStrategy.Firestore,
    cache: CacheStrategy.InMemory,
});
export { PREFERENCE_ENTITY };
//# sourceMappingURL=preferences.descriptor.js.map